<template>
	<transition name="modal">
		<div class="modal-mask">
			<div class="modal-wrapper" @click="$emit('closeModal')">
				<div class="row">
					<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
					<div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
						<div class="modal-container" @click.stop>

						<div class="modal-header row" style="justify-content: flex-end;">
							<!-- <div class="col-6">
							<button type="button" class="btn btn-sm btn-outline-primary" @click="$emit('newUserBack')">< Back</button>
							</div> -->
							<div class="col">
							<button type="button" class="close" @click="$emit('closeModal')">
								<span aria-hidden="true">&times;</span>
							</button>
							</div>
						</div>
						<!-- Start Modal Body -->
						<div class="modal-body">
							<h4 class="title">Isi Absensi Pekerja</h4>


							<label class="label text-left ml-3">Tipe Pengisian Absensi</label>
							<div class="row ml-2">
								<div class="col-md-4 col-6" style="padding-right:0;">
									<button 
										class="btn w-100 border border-info" 
										:class="{'btn-info' : inputType == 'document', 'btn-outline-info' : inputType != 'mesin'}" 
										style="border-radius:5px 0px 0px 5px;border-right: none" type="button"
										@click="inputType = 'document'"
									>
										Dokumen Excel
									</button>
								</div>
								<div class="col-md-4 col-6" style="padding-left:0">
									<button 
										class="btn w-100 border border-info" 
										:class="{'btn-info' : inputType == 'mesin', 'btn-outline-info' : inputType != 'document'}" 
										style="border-radius:0px 5px 5px 0px;" type="button"
										@click="inputType = 'mesin'"
									>
										Mesin Fingerprint
									</button>
								</div>
							</div>

							<div  v-if="inputType == 'document'">
								<div class="row row-space">
									<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
										<div class="input-group">
											<label class="label">Unggah Dokumen Absensi<span style="color: red;">*</span></label>
											<input type="file"  class="input--style-4" @change="validateSize" multiple/>
										</div>
									</div>
								</div>

								<div class="row">
									<div class="col mt-5" style="text-align: center">
										<button type="button" class="btn btn-outline-danger" style="font-size:140%" @click="$emit('closeModal')">Kembali</button>
										<button type="button" class="btn btn-primary ml-5" style="font-size:150%" @click="submitForm('Main')">Unggah</button>
									</div>
								</div>
							</div>

							<div v-else>
								<div class="row row-space">
									<div class="col-12">
										<div class="input-group">
											<label class="label">Dari Tanggal<span style="color: red;">*</span></label>
											<flat-pickr
												v-model="filter.start_date"
												:config="rangeConfig"
												placeholder="Pilih Tanggal"
											></flat-pickr>
										</div>
									</div>
								</div>
								<div class="row row-space">
									<div class="col-12">
										<div class="input-group">
											<label class="label">Sampai Tanggal :<span style="color: red;">*</span></label>
											<flat-pickr
												v-model="filter.end_date"
												:config="rangeConfig"
												placeholder="Pilih Tanggal"
											></flat-pickr>
										</div>
									</div>
								</div>

								<div class="row">
									<div class="col mt-5" style="text-align: center">
										<button type="button" class="btn btn-outline-danger" style="font-size:140%" @click="$emit('closeModal')">Kembali</button>
										<button type="button" class="btn btn-primary ml-5" style="font-size:150%" @click="submitMachineAttendance()">Unggah</button>
									</div>
								</div>
							</div>

                

							

              
						</div>
						<!-- End Modal Body -->
					</div>
				</div>
			</div>
			<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
		</div>
  </div>

 
</transition>
</template>

<script>
import moment from 'moment'
export default {
	data () {
		return {
			file : null,
			fileError : null,
			inputType : 'document',
			rangeConfig: {
				altInput: true,
				altInputClass: ' input--style-4 flatpickr-input w-100',
				animate: !this.isRTL()
			},
			filter : {
				start_date : null,
				end_date : null
			}
		}
	},
  	mounted() {
    },
	methods : {
		validateSize : function(data){
					
			var file = data.target.files;

			if(file.length > 1) {
				this.fileError = "Maksimum Dokumen Di Unggah : 1 Dokumen";
				return false;
			}

			var size  = file.size / 1024 / 1024;

			if(size > 20)
			{
				this.fileError = "Maksimum Size Dokumen 10 MB";
				return false;
			}

			this.fileError = "";
			this.file = file
			return true;
		},
		validateForm(type){
			var valid = true;
			var error = [];
			

			if(this.file == '' || this.file == null){//Sparepart [Required]
				valid = false;
				error.push('File SPK Tidak boleh kosong!');
			}

			if(!valid) this.$store.dispatch('triggerAlert', [false, error]);
        	else return valid;
		},
		submitForm(type) {
			if(this.validateForm(type)){
				let formData = new FormData()
				formData.append('file' , this.file[0])

				this.$http.post(`/api/v1/attendance/file`, formData ,  {headers : {"Content-Type":'multipart/form-data'}})
				.then((resp) => {
					this.$store.dispatch('triggerAlert', [true, [`Absensi Berhasil Di Input`]]);
					this.$emit('updateTable');
					this.$emit('closeModal');
				})
				.catch((err) => {
					console.log(err)
				})
			}
					
		},
		submitMachineAttendance() {
			if(this.validateFormMachine(this.filter)) {
				let url = `/api/v1/att-machine/insert?start_date=${this.filter.start_date}&end_date=${this.filter.end_date}`
				this.$http.get(url)
				.then((resp) => {
					this.$store.dispatch('triggerAlert', [true, [`Absensi Berhasil Di Input`]]);
					this.$emit('updateTable');
					this.$emit('closeModal');
				})
				.catch((err) => {
					this.$store.dispatch('triggerAlert' , [false, ['Absensi Sedang Diprocess. Jika Absensi belum terprocess melebihi 5 menit, Mohon Hubungi Administrator.']])
					console.log(err)

				})
			}
		},
		validateFormMachine(data) {
			var valid = true;
			var error = [];
			

			if(data.start_date == '' || data.start_date == null){//Sparepart [Required]
				valid = false;
				error.push('Tanggal Dari Tidak boleh kosong!');
			}

			if(data.end_date == '' || data.end_date == null){//Sparepart [Required]
				valid = false;
				error.push('Tanggal Sampai Tidak boleh kosong!');
			}

			if(!valid) this.$store.dispatch('triggerAlert', [false, error]);
        	else return valid;
		}
	},
	props : []
}
</script>

<style>

/* ==========================================================================
#FORM made by Colorlib (https://colorlib.com)
========================================================================== */
input {
  outline: none;
  margin: 0;
  border: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  width: 100%;
  font-size: 14px;
  font-family: inherit;
}

.input--style-4 {
  line-height: 50px;
  background: #fafafa;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  padding: 0 20px;
  font-size: 16px;
  color: #666;
  -webkit-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #666;
}

.input--style-4:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #666;
  opacity: 1;
}

.input--style-4::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #666;
  opacity: 1;
}

.input--style-4:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #666;
}

.input--style-4:-ms-input-placeholder {
  /* Microsoft Edge */
  color: #666;
}

.label {
  font-size: 16px;
  color: #555;
  text-transform: capitalize;
  display: block;
  margin-bottom: 5px;
}

.radio-container {
  display: inline-block;
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  font-size: 16px;
  color: #666;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
  background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
  display: block;
}

.radio-container .checkmark:after {
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background: #57b846;
}

.checkmark {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #e5e5e5;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.input-group {
  position: relative;
  /* margin-bottom: 22px; */
  padding:20px;
}

.input-group-icon {
  position: relative;
}

.input-icon {
  position: absolute;
  font-size: 18px;
  color: #999;
  right: 18px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  cursor: pointer;
}

/* ==========================================================================
    #TITLE made by Colorlib (https://colorlib.com)
    ========================================================================== */
.title {
  font-size: 40px;
  color: #525252;
  margin-bottom: 40px;
  text-align: center;
}


/* FILE DRAG N' DROP START */
.dropZone {
  /* width: 80%; */
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone:hover {
  border: 2px solid #2e94c4;
}

.dropZone:hover .dropZone-title {
  color: #1975A0;
}

.dropZone-info {
  color: #A8A8A8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.dropZone-title {
  color: #787878;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.dropZone-over {
  background: #5C5C5C;
  opacity: 0.8;
}

.dropZone-uploaded {
  /* width: 80%; */
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #A8A8A8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.removeFile {
  width: 200px;
}
/* FILE DRAG N' DROP END */


</style>
